import React, { useEffect } from 'react';

import '../../styles/teacherView.shell.scss';
import '../../styles/teacherView.chrome.scss';

const TEACHER_CHROME_BODY_CLASS = 'teacher-chrome';

/** @typedef {'slate' | 'stone' | 'blueprint'} TeacherShellVariant */
/** @typedef {'bookends' | 'light' | 'split'} TeacherChromeVariant */

const VARIANT_CLASS = {
  slate: 'teacher-view-shell--slate',
  stone: 'teacher-view-shell--stone',
  blueprint: 'teacher-view-shell--blueprint',
};

const CHROME_CLASS = {
  bookends: 'teacher-chrome--bookends',
  light: 'teacher-chrome--light',
  split: 'teacher-chrome--split',
};

/**
 * Neutral teacher workspace shell. Variant selects outer background (default: blueprint).
 *
 * @param {object} props
 * @param {'slate' | 'stone' | 'blueprint'} [props.variant='blueprint']
 * @param {'bookends' | 'light' | 'split'} [props.chromeVariant='split']
 * @param {string} [props.className]
 */
export default function TeacherPageShell({
  variant = 'blueprint',
  chromeVariant = 'split',
  className,
  children,
}) {
  const variantClass = VARIANT_CLASS[variant] ?? VARIANT_CLASS.blueprint;
  const chromeClass = CHROME_CLASS[chromeVariant] ?? CHROME_CLASS.split;

  useEffect(() => {
    const appContent = document.querySelector('.appContent');
    document.body.classList.add(TEACHER_CHROME_BODY_CLASS, chromeClass);

    if (!appContent) {
      return () => {
        document.body.classList.remove(TEACHER_CHROME_BODY_CLASS, chromeClass);
      };
    }

    appContent.dataset.teacherVariant = variant;

    return () => {
      document.body.classList.remove(TEACHER_CHROME_BODY_CLASS, chromeClass);
      delete appContent.dataset.teacherVariant;
    };
  }, [variant, chromeClass]);

  const combinedClass = ['teacher-view-shell', variantClass, className].filter(Boolean).join(' ');

  return <div className={combinedClass}>{children}</div>;
}
